import {
    ActionBarContext,
    addActionBarItem,
    getServerLocation,
    NotificationService,
    registerFormInputComponent,
} from '@vendure/admin-ui/core';
import { DatetimeFormFieldComponent } from './components/datetime-form-field/datetime-form-field.component';
import axios from 'axios';

export default [
    registerFormInputComponent('datetime-form-field', DatetimeFormFieldComponent),
    addActionBarItem({
        id: 'cancel-order',
        locationId: 'global-setting-detail',
        label: 'Cancel 0$ Order',
        icon: 'cross',
        requiresPermission: 'SuperAdmin',
        buttonColor: 'warning',
        onClick: async (event: MouseEvent, context: ActionBarContext) => {
            const notificationService = context.injector.get(NotificationService);
            const serverPath = getServerLocation();

            axios
                .get(`${serverPath}/scripts/orders/cancel-order`, {
                    headers: {
                        Authorization: '709fcc3d-d549-41f1-8a75-959ad49f4b6c',
                    },
                })
                .then(({ data }) => {
                    notificationService.success(`Cancel Order: ${data.message}`);
                })
                .catch(err => {
                    // console.error(err);
                    notificationService.error('Error occurred cancelling orders.');
                });
        },
    }),
];
